import React from 'react'
import { SvgIcon } from '@material-ui/core'

function CheckMarkIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Path'
        d='M10.2232 17.6065C10.0255 17.8191 9.68883 17.8191 9.49107 17.6065L5.13371 12.923C4.77657 12.5391 4.77657 11.9446 5.13372 11.5607L5.27959 11.4039C5.67474 10.9792 6.34719 10.9787 6.74293 11.4029L9.49104 14.3485C9.6889 14.5606 10.0251 14.5603 10.2227 14.348L17.2546 6.78973C17.651 6.36358 18.3263 6.36477 18.7212 6.79232L18.8709 6.95434C19.2258 7.33848 19.2247 7.93118 18.8685 8.31407L10.2232 17.6065Z'
      />
    </SvgIcon>
  )
}

export default CheckMarkIcon
